(function () {
  var MOBILE_QUERY = '(max-width: 767px)';
  var DESKTOP_GAP = 24;
  var MOBILE_GAP = 16;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getSlideCount(root) {
    var count = parseInt(root.getAttribute('data-slide-count') || '0', 10);
    return Number.isFinite(count) ? count : 0;
  }

  function buildConfig(root) {
    var slideCount = getSlideCount(root);
    var mobile = isMobile();

    return {
      slidesPerView: mobile ? 1 : 3,
      spaceBetween: mobile ? MOBILE_GAP : DESKTOP_GAP,
      centeredSlides: true,
      loop: slideCount > 1,
      loopedSlides: slideCount,
      speed: 550,
      autoHeight: false,
      observer: false,
      observeParents: false,
      watchSlidesProgress: true,
      autoplay: slideCount > 1
        ? {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,
      pagination: {
        el: root.querySelector('.sydney-marathon-2026-swiper__pagination'),
        clickable: true
      },
      navigation: {
        nextEl: root.querySelector('.sydney-marathon-2026-swiper__nav-btn--next'),
        prevEl: root.querySelector('.sydney-marathon-2026-swiper__nav-btn--prev')
      }
    };
  }

  function SydneyMarathon2026Swiper(root) {
    this.root = root;
    this.swiper = null;
    this.mediaQuery = window.matchMedia(MOBILE_QUERY);
    this.onMediaChange = this.handleMediaChange.bind(this);
    this.initImpressionTracking();
    this.createSwiper();

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.onMediaChange);
    } else {
      this.mediaQuery.addListener(this.onMediaChange);
    }
  }

  SydneyMarathon2026Swiper.prototype.initImpressionTracking = function () {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    var moduleName = this.root.getAttribute('data-module-impression') || 'upcoming_race';
    var tracked = false;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (tracked || !entry.isIntersecting) {
            return;
          }

          var rect = entry.boundingClientRect;
          var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          var isBottomInViewport = rect.bottom > 0 && rect.bottom <= viewportHeight;

          if (!isBottomInViewport) {
            return;
          }

          tracked = true;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'module_impression',
            event_parameters: {
              module: moduleName,
            },
          });
          observer.disconnect();
        });
      },
      { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    );

    observer.observe(this.root);
  };

  SydneyMarathon2026Swiper.prototype.createSwiper = function () {
    if (typeof Swiper === 'undefined') return;

    var swiperEl = this.root.querySelector('.sydney-marathon-2026-swiper__swiper');
    if (!swiperEl || getSlideCount(this.root) === 0) return;
    this.swiper = new Swiper(swiperEl, buildConfig(this.root));
  };

  SydneyMarathon2026Swiper.prototype.handleMediaChange = function () {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.createSwiper();
  };

  SydneyMarathon2026Swiper.prototype.destroy = function () {
    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener('change', this.onMediaChange);
    } else {
      this.mediaQuery.removeListener(this.onMediaChange);
    }

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  };

  function bootAll() {
    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', bootAll, { once: true });
      return;
    }

    document.querySelectorAll('sydney-marathon-2026-swiper').forEach(function (el) {
      if (el._sm2026Swiper) return;
      el._sm2026Swiper = new SydneyMarathon2026Swiper(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
